(() => {
  const clock = document.querySelector('[data-live-clock]');
  const date = document.querySelector('[data-live-date]');
  const zone = document.querySelector('[data-live-zone]');

  if (!clock || !date || !zone || !('Intl' in window)) return;

  const timeFormatter = new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hourCycle: 'h23'
  });
  const dateFormatter = new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
  const zoneFormatter = new Intl.DateTimeFormat(undefined, {
    timeZoneName: 'short'
  });

  let timer;

  const render = () => {
    const now = new Date();
    const visibleTime = timeFormatter.format(now);
    const visibleDate = dateFormatter.format(now).toUpperCase();
    const visibleZone = zoneFormatter
      .formatToParts(now)
      .find(part => part.type === 'timeZoneName')?.value || 'LOCAL';

    clock.textContent = visibleTime;
    clock.dateTime = now.toISOString();
    clock.setAttribute('aria-label', `Local time ${visibleTime}, ${visibleDate}, ${visibleZone}`);
    date.textContent = visibleDate;
    zone.textContent = visibleZone;

    window.clearTimeout(timer);
    timer = window.setTimeout(render, 1010 - (Date.now() % 1000));
  };

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) render();
  });

  render();
})();
